import { normalizeRevisionAdviceText } from '../listing-draft-payload.js';

export function createRevisionSuggestionsController({
  select,
  getState,
  renderEmpty,
  renderCards,
  syncApplyButton,
  addSearchTerm,
  showToast,
} = {}) {
  function bindEvents(list) {
    list?.querySelectorAll('.revision-expand-toggle').forEach((button) => {
      button.addEventListener('click', () => {
        const id = button.dataset.id;
        const body = [...list.querySelectorAll('.revision-card-body')]
          .find((element) => element.dataset.bodyId === id);
        if (!body) return;
        const collapsed = body.classList.toggle('is-collapsed');
        button.textContent = collapsed ? '展开细项' : '收起细项';
      });
    });

    list?.querySelectorAll('.revision-adopt-keyword').forEach((button) => {
      button.addEventListener('click', () => {
        const keyword = button.dataset.keyword || '';
        const added = addSearchTerm(keyword);
        if (added.length) {
          showToast(`已采纳到 Search Terms：${added.join(', ')}`);
          button.disabled = true;
          button.textContent = '已采纳';
        } else {
          showToast('未提取到可用关键词，请手动编辑 Search Terms', true);
        }
      });
    });
  }

  function render() {
    const suggestions = getState('revisionSuggestions') || [];
    const revisionAdviceText = normalizeRevisionAdviceText(getState('revisionAdviceText') || '');
    const suggestionsError = getState('revisionSuggestionsError') || '';
    const overview = getState('revisionOverview') || null;
    const result = select('#revision-result');
    const list = select('#revision-suggestions-list');

    if (result) result.hidden = false;
    if (!suggestions.length) {
      renderEmpty(list, { revisionAdviceText, suggestionsError });
      syncApplyButton();
      return;
    }
    renderCards(list, { overview, suggestions, notice: suggestionsError });
    syncApplyButton();
    bindEvents(list);
  }

  return { render };
}
